// extracted by mini-css-extract-plugin
export default {"comparison":"WdB2jpi397GPWMeoZm_v"};